const resources = [{
    "id": 1238653,
    "type": "pdf",
    "src": "https:\/\/appetiteapp.chubb.com\/pdf\/t2-auto-12-18.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/auto.jpg",
    "title": "Auto Overview",
    "description": "Learn more about our Commercial Auto insurance product",
    "recent": true,
    "emailSubject": "Chubb's Auto Insurance Product",
    "emailBody": ["You may be interested in this brochure about Chubb's Commercial Auto insurance product.  Take a look!"],
    "facebook": "You may be interested in this brochure about Chubb's Commercial Auto insurance product.  Take a look!",
    "twitter": "You may be interested in this brochure about Chubb's Commercial Auto insurance product.  Take a look!",
    "linkedin": "You may be interested in this brochure about Chubb's Commercial Auto insurance product.  Take a look!",
    "labels": "",
    "associations": [1169614]
}, {
    "id": 1242838,
    "type": "pdf",
    "src": "https:\/\/www.chubb.com\/us-en\/_assets\/doc\/wp-cleantech-11-18.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/cleantech_thumbnail@2x.jpg",
    "title": "Cleantech’s Global Balancing Act",
    "description": "A special report on the future of cleantech",
    "recent": true,
    "emailSubject": "Cleantech's Global Balancing Act",
    "emailBody": ["Check out this special report from Chubb detailing how cleantech executives feel about what lies ahead, steps to mitigate key risks as they grow, and how to leverage technologies and relationships."],
    "facebook": "Check out this special report from Chubb detailing how cleantech executives feel about what lies ahead, steps to mitigate key risks as they grow, and how to leverage technologies and relationships",
    "twitter": "Check out this special report from Chubb detailing how cleantech executives feel about what lies ahead, steps to mitigate key risks as they grow, and how to leverage technologies and relationships",
    "linkedin": "Check out this special report from Chubb detailing how cleantech executives feel about what lies ahead, steps to mitigate key risks as they grow, and how to leverage technologies and relationships",
    "labels": "",
    "associations": [1169536]
}, {
    "id": 1244330,
    "type": "pdf",
    "src": "https:\/\/appetiteapp.chubb.com\/pdf\/t2-cyber-01-19.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/cyber.jpg",
    "title": "Cyber Overview",
    "description": "Learn more about our Cyber insurance solutions",
    "recent": true,
    "emailSubject": "Chubb's Cyber Insurance Solutions",
    "emailBody": ["You may be interested in this brochure about Chubb's Cyber insurance solutions.  Take a look! "],
    "facebook": "You may be interested in this brochure about Chubb's Cyber insurance solutions.  Take a look! ",
    "twitter": "You may be interested in this brochure about Chubb's Cyber insurance solutions.  Take a look! ",
    "linkedin": "You may be interested in this brochure about Chubb's Cyber insurance solutions.  Take a look! ",
    "labels": "",
    "associations": [1169602]
}, {
    "id": 1240943,
    "type": "pdf",
    "src": "https:\/\/appetiteapp.chubb.com\/pdf\/t2-equipment-12-18.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/equipment-breakdown@2x.jpg",
    "title": "Equipment Breakdown Overview",
    "description": "Learn more about our Equipment Breakdown insurance solutions",
    "recent": true,
    "emailSubject": "Chubb's Equipment Breakdown Insurance Products",
    "emailBody": ["You may be interested in this brochure about Chubb's Equipment Breakdown insurance products.  Take a look! "],
    "facebook": "You may be interested in this brochure about Chubb's Equipment Breakdown insurance products.  Take a look! ",
    "twitter": "You may be interested in this brochure about Chubb's Equipment Breakdown insurance products.  Take a look! ",
    "linkedin": "You may be interested in this brochure about Chubb's Equipment Breakdown insurance products.  Take a look! ",
    "labels": "",
    "associations": [1169611]
}, {
    "id": 1277230,
    "type": "pdf",
    "src": "https:\/\/www.chubb.com\/_global-assets\/documents\/t2-excessumb-7-19.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/webapp_product_excessumbrella@2x.jpg",
    "title": "Excess and Umbrella Overview",
    "description": "Learn more about our Excess and Umbrella insurance solutions",
    "recent": true,
    "emailSubject": "Chubb's Excess and Umbrella Insurance Solutions",
    "emailBody": ["You may be interested in this brochure about Chubb's Excess and Umbrella insurance solutions.  Take a look! "],
    "facebook": "You may be interested in this brochure about Chubb's Excess and Umbrella insurance solutions.  Take a look! ",
    "twitter": "You may be interested in this brochure about Chubb's Excess and Umbrella insurance solutions.  Take a look! ",
    "linkedin": "You may be interested in this brochure about Chubb's Excess and Umbrella insurance solutions.  Take a look! ",
    "labels": "",
    "associations": [1169618]
}, {
    "id": 1238679,
    "type": "pdf",
    "src": "https:\/\/appetiteapp.chubb.com\/pdf\/t2-fedctrs-12-18.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/lp_industry_federalcontractors.jpg",
    "title": "Federal Contractors Overview",
    "description": "Learn more about our Federal Contractors Industry Practice",
    "recent": true,
    "emailSubject": "Chubb's Federal Contractors Industry Practice",
    "emailBody": ["Check out how Chubb is well-positioned to proactively help Federal Contractors face an ever-expanding array of complex exposures."],
    "facebook": "You might be interested in this brochure about Chubb's Federal Contractors industry practice. Take a look.",
    "twitter": "You might be interested in this brochure about Chubb's Federal Contractors industry practice. Take a look.",
    "linkedin": "You might be interested in this brochure about Chubb's Federal Contractors industry practice. Take a look.",
    "labels": "",
    "associations": [1169537]
}, {
    "id": 1274666,
    "type": "pdf",
    "src": "https:\/\/www.chubb.com\/_global-assets\/documents\/t3-fgc-7-19.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/webapp_product_fgc@2x.jpg",
    "title": "Federal Contractors Immunnity",
    "description": "FGCs – When Immunitiy Is Not Enough",
    "recent": true,
    "emailSubject": "Federal Government Contractors — When Immunity Is Not Enough",
    "emailBody": ["Think You’re Protected by Federal Government Contractor Immunities? Think Again.  Access Chubb’s latest advisory to learn more."],
    "facebook": "Think You’re Protected by Federal Government Contractor Immunities? Think Again.  Access Chubb’s latest advisory to learn more.",
    "twitter": "Think You’re Protected by Federal Government Contractor Immunities? Think Again.  Access Chubb’s latest advisory to learn more.",
    "linkedin": "Think You’re Protected by Federal Government Contractor Immunities? Think Again.  Access Chubb’s latest advisory to learn more.",
    "labels": "",
    "associations": [1169537]
}, {
    "id": 1240944,
    "type": "pdf",
    "src": "https:\/\/www.chubb.com\/_global-assets\/documents\/t2-gl-12-18.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/general-liability@2x.jpg",
    "title": "General Liability",
    "description": "Learn more about our General Liability insurance solutions",
    "recent": true,
    "emailSubject": "Chubb's General Liability Insurance Products",
    "emailBody": ["You may be interested in this brochure about Chubb's General Liability insurance products. Take a look! "],
    "facebook": "You may be interested in this brochure about Chubb's General Liability insurance products. Take a look! ",
    "twitter": "You may be interested in this brochure about Chubb's General Liability insurance products. Take a look! ",
    "linkedin": "You may be interested in this brochure about Chubb's General Liability insurance products. Take a look! ",
    "labels": "",
    "associations": [1169613]
}, {
    "id": 1249848,
    "type": "pdf",
    "src": "https:\/\/appetiteapp.chubb.com\/pdf\/t2-marinefac-3-19.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/webapp_industry_marinefacilities@2x.jpg",
    "title": "Marine Facilities Overview",
    "description": "Learn more about our Marine Facilities Industry Practice",
    "recent": true,
    "emailSubject": "Chubb's Marine Facilities Industry Practice",
    "emailBody": ["Check out how Chubb is well-positioned to craft holistic insurance solutions to address the Marine Facilities industry."],
    "facebook": "You might be interested in this brochure about Chubb's Marine Facilities industry practice. Take a look.",
    "twitter": "You might be interested in this brochure about Chubb's Marine Facilities industry practice. Take a look.",
    "linkedin": "You might be interested in this brochure about Chubb's Marine Facilities industry practice. Take a look.",
    "labels": "",
    "associations": [1249841, 1249858]
}, {
    "id": 1238663,
    "type": "pdf",
    "src": "https:\/\/appetiteapp.chubb.com\/pdf\/t2-multinatl-12-18.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/multinational.jpg",
    "title": "Multinational Overview",
    "description": "Learn more about our Multinational insurance solutions",
    "recent": true,
    "emailSubject": "Chubb's Multinational Insurance Products",
    "emailBody": ["You may be interested in this brochure about Chubb's Multinational insurance products and services.  Take a look!"],
    "facebook": "You may be interested in this brochure about Chubb's Multinational insurance products and services.  Take a look!",
    "twitter": "You may be interested in this brochure about Chubb's Multinational insurance products and services.  Take a look!",
    "linkedin": "You may be interested in this brochure about Chubb's Multinational insurance products and services.  Take a look!",
    "labels": "",
    "associations": [1169617]
}, {
    "id": 1256976,
    "type": "pdf",
    "src": "https:\/\/appetiteapp.chubb.com\/pdf\/t3-flood-3-19.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/webapp_industry_flood@2x.jpg",
    "title": "Property Flood Endorsement Overview",
    "description": "Learn more about our Property Flood Endorsement",
    "recent": true,
    "emailSubject": "Chubb's Property Flood Endorsement",
    "emailBody": ["You may be interested in this brochure about Chubb's Property Flood Endorsement.  Take a look! "],
    "facebook": "You may be interested in this brochure about Chubb's Property Flood Endorsement.  Take a look!",
    "twitter": "You may be interested in this brochure about Chubb's Property Flood Endorsement.  Take a look!",
    "linkedin": "You may be interested in this brochure about Chubb's Property Flood Endorsement.  Take a look!",
    "labels": "",
    "associations": [1169616]
}, {
    "id": 1238669,
    "type": "pdf",
    "src": "https:\/\/appetiteapp.chubb.com\/pdf\/t2-property-12-18.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/property@2x.jpg",
    "title": "Property Overview",
    "description": "Learn more about our Property insurance solutions",
    "recent": true,
    "emailSubject": "Chubb's Property Insurance Products",
    "emailBody": ["You may be interested in this brochure about Chubb's Property insurance products and services.  Take a look!"],
    "facebook": "You may be interested in this brochure about Chubb's Property insurance products and services.  Take a look!",
    "twitter": "You may be interested in this brochure about Chubb's Property insurance products and services.  Take a look!",
    "linkedin": "You may be interested in this brochure about Chubb's Property insurance products and services.  Take a look!",
    "labels": "",
    "associations": [1169616]
}, {
    "id": 1238672,
    "type": "pdf",
    "src": "https:\/\/appetiteapp.chubb.com\/pdf\/t2-publicentity-8-18.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/lp_industry_publicentity.jpg",
    "title": "Public Entity Overview",
    "description": "Learn more about our Public Entity Industry Practice",
    "recent": true,
    "emailSubject": "Chubb's Public Entity Industry Practice",
    "emailBody": ["Check out how Chubb is well-positioned to proactively help Public Entity businesses face an ever-expanding array of complex exposures."],
    "facebook": "You might be interested in this brochure about Chubb's Public Entity industry practice. Take a look.",
    "twitter": "You might be interested in this brochure about Chubb's Public Entity industry practice. Take a look.",
    "linkedin": "You might be interested in this brochure about Chubb's Public Entity industry practice. Take a look.",
    "labels": "",
    "associations": [1169562]
}, {
    "id": 1169244,
    "type": "video",
    "src": "https:\/\/youtu.be\/s3BjFNulkdA",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/video-ip-circle.jpg",
    "title": "Chubb Commercial Industry Practices Overview",
    "description": "Check out our Industry Practices video",
    "recent": false,
    "emailSubject": "Helping you grow your business",
    "emailBody": ["See how Chubb is best positioned to help you build your business and meet the needs of clients across a variety of industries and geographies."],
    "facebook": "See how Chubb is best positioned to help you build your business and meet the needs of clients across a variety of industries and geographies.",
    "twitter": "See how Chubb is best positioned to help you build your business and meet the needs of clients across a variety of industries and geographies.",
    "linkedin": "See how Chubb is best positioned to help you build your business and meet the needs of clients across a variety of industries and geographies.",
    "labels": "",
    "associations": [1169614, 1169602, 1169605, 1169608, 1169603, 1169611, 1169607, 1169604, 1169613, 1169610, 1169619, 1169617, 1169609, 1169606, 1169615, 1169616, 1169618, 1169612, 1169544, 1169545, 1169555, 1169546, 1169572, 1169576, 1169556, 1169573, 1169540, 1169547, 1169577, 1169536, 1169592, 1169557, 1169567, 1169558, 1169559, 1169593, 1169560, 1169578, 1169579, 1169537, 1169541, 1169580, 1169568, 1169598, 1169561, 1169581, 1169548, 1169574, 1169549, 1169582, 1169599, 1169594, 1169583, 1254995, 1249858, 1169595, 1169584, 1169551, 1169569, 1169600, 1169585, 1169552, 1169596, 1254996, 1169553, 1169586, 1169538, 1169562, 1169563, 1169587, 1169570, 1169588, 1169542, 1169589, 1169564, 1169565, 1169590]
}, {
    "id": 1191041,
    "type": "pdf",
    "src": "https:\/\/www.chubb.com\/_global-assets\/documents\/t2-entertain-3-18-1.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/webapp_industry_entertainment.jpg",
    "title": "Entertainment Overview",
    "description": "Learn more about our Entertainment Industry Practice",
    "recent": true,
    "emailSubject": "Chubb's Entertainment Industry Practice",
    "emailBody": ["Check out how Chubb's deep expertise can help entertainment companies manage risk in today's diverse and dynamic entertainment environment."],
    "facebook": "You might be interested in this brochure about Chubb's Entertainment industry practice. Take a look.",
    "twitter": "You might be interested in this brochure about Chubb's Entertainment industry practice. Take a look.",
    "linkedin": "You might be interested in this brochure about Chubb's Entertainment industry practice. Take a look.",
    "labels": "",
    "associations": [1169541, 1169542]
}, {
    "id": 1191045,
    "type": "pdf",
    "src": "https:\/\/www.chubb.com\/_global-assets\/documents\/t2-fi-7-18-1.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/webapp_industry_federalcontractors.jpg",
    "title": "Financial Institutions Overview",
    "description": "Learn more about our Financial Institutions Industry Practice",
    "recent": true,
    "emailSubject": "Chubb's Financial Institutions Industry Practice",
    "emailBody": ["Check out how Chubb is well-positioned to proactively help Financial Institutions face an ever-expanding array of complex exposures."],
    "facebook": "You might be interested in this brochure about Chubb's Financial Institutions industry practice. Take a look.",
    "twitter": "You might be interested in this brochure about Chubb's Financial Institutions industry practice. Take a look.",
    "linkedin": "You might be interested in this brochure about Chubb's Financial Institutions industry practice. Take a look.",
    "labels": "",
    "associations": [1169572, 1169573, 1169574]
}, {
    "id": 1191047,
    "type": "pdf",
    "src": "https:\/\/www.chubb.com\/_global-assets\/documents\/t2-oceanmarine-7-18-1.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/webapp_product_oceanmarine.jpg",
    "title": "Ocean Marine Overview",
    "description": "Learn more about our Ocean Marine insurance solutions",
    "recent": true,
    "emailSubject": "Chubb's Ocean Marine Insurance Products",
    "emailBody": ["Check out how Chubb's is well positioned to provide integrated insurance for a wide range of marine-related facilities."],
    "facebook": "You might be interested in this brochure about Chubb's Ocean Marine insurance products. Take a look.",
    "twitter": "You might be interested in this brochure about Chubb's Ocean Marine insurance products. Take a look.",
    "linkedin": "You might be interested in this brochure about Chubb's Ocean Marine insurance products. Take a look.",
    "labels": "",
    "associations": [1169609]
}, {
    "id": 1199736,
    "type": "pdf",
    "src": "https:\/\/appetiteapp.chubb.com\/pdf\/t2-integrity-8-18.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/chubb_t2-integrity_webapp_081018_@1x.jpg",
    "title": "E&O - Integrity+ by Chubb®",
    "description": "Learn more about our E&O product Integrity+ by Chubb®",
    "recent": true,
    "emailSubject": "Chubb's E&O product Integrity+ by Chubb®",
    "emailBody": ["Check out why Chubb's E&O product Integrity+ by Chubb® is the preferred insurance solution for a broad array of businesses."],
    "facebook": "You might be interested in this brochure about Chubb's E&O product Integrity+ by Chubb®. Take a look.",
    "twitter": "You might be interested in this brochure about Chubb's E&O product Integrity+ by Chubb®. Take a look.",
    "linkedin": "You might be interested in this brochure about Chubb's E&O product Integrity+ by Chubb®. Take a look.",
    "labels": "",
    "associations": [1169615, 1169576, 1169577, 1169592, 1169567, 1169593, 1169578, 1169579, 1169580, 1169568, 1169581, 1169594, 1169582, 1169595, 1169569, 1169585, 1169596, 1169586, 1169587, 1169570, 1169588, 1169589, 1169590]
}, {
    "id": 1201007,
    "type": "pdf",
    "src": "https:\/\/appetiteapp.chubb.com\/pdf\/t2-energy-8-18.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/chubb_t2-energy_webapp_082218_@1x.jpg",
    "title": "Energy Overview",
    "description": "Learn more about our Energy Industry Practice",
    "recent": true,
    "emailSubject": "Chubb's Energy Industry Practice",
    "emailBody": ["Check out how Chubb is well-positioned to proactively help Energy face an ever-expanding array of complex exposures."],
    "facebook": "You might be interested in this brochure about Chubb's Energy industry practice. Take a look.",
    "twitter": "You might be interested in this brochure about Chubb's Energy industry practice. Take a look.",
    "linkedin": "You might be interested in this brochure about Chubb's Energy industry practice. Take a look.",
    "labels": "",
    "associations": [1169551, 1169552, 1169553]
}, {
    "id": 1210002,
    "type": "pdf",
    "src": "https:\/\/appetiteapp.chubb.com\/pdf\/t2-food-9-18.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/food-thumbnail@2x.jpg",
    "title": "Food Overview",
    "description": "Learn more about our Food Industry Practice",
    "recent": true,
    "emailSubject": "Chubb's Food Industry Practice",
    "emailBody": ["Check out how Chubb is well-positioned to proactively help businesses in the Food industry face an ever-expanding array of complex exposures."],
    "facebook": "You might be interested in this brochure about Chubb's Food industry practice. Take a look.",
    "twitter": "You might be interested in this brochure about Chubb's Food industry practice. Take a look.",
    "linkedin": "You might be interested in this brochure about Chubb's Food industry practice. Take a look.",
    "labels": "",
    "associations": [1169580]
}, {
    "id": 1210013,
    "type": "pdf",
    "src": "https:\/\/appetiteapp.chubb.com\/pdf\/t2-healthcare-9-18.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/healthcare-thumbnail@2x.jpg",
    "title": "Healthcare Overview",
    "description": "Learn more about our Healthcare Industry Practice",
    "recent": true,
    "emailSubject": "Chubb's Healthcare Industry Practice",
    "emailBody": ["Check out how Chubb is well-positioned to proactively help businesses in the Healthcare industry face an ever-expanding array of complex exposures."],
    "facebook": "You might be interested in this brochure about Chubb's Healthcare industry practice. Take a look.",
    "twitter": "You might be interested in this brochure about Chubb's Healthcare industry practice. Take a look.",
    "linkedin": "You might be interested in this brochure about Chubb's Healthcare industry practice. Take a look.",
    "labels": "",
    "associations": [1169598, 1169599, 1254995, 1169600, 1254996]
}, {
    "id": 1229910,
    "type": "pdf",
    "src": "https:\/\/appetiteapp.chubb.com\/pdf\/t2-ah-11-18.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/chubb_accidentandhealth_thumbnail.jpg",
    "title": "Accident & Health Overview",
    "description": "Learn more about our A&H products",
    "recent": true,
    "emailSubject": "Chubb's Accident & Health Products",
    "emailBody": ["Take a deeper dive to learn more about Chubb’s Accident & Health products."],
    "facebook": "Take a deeper dive to learn more about Chubb’s Accident & Health products.",
    "twitter": "Take a deeper dive to learn more about Chubb’s Accident & Health products.",
    "linkedin": "Take a deeper dive to learn more about Chubb’s Accident & Health products.",
    "labels": "",
    "associations": [1206511]
}, {
    "id": 1169245,
    "type": "video",
    "src": "https:\/\/youtu.be\/0w1mWS1Oido",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/video-scott.jpg",
    "title": "Rediscover Commercial Insurance",
    "description": "Helping you grow your business. See how Chubb is best positioned to help you build your business and meet the needs of clients across a variety of industries and geographies.",
    "recent": false,
    "emailSubject": "Rediscover Customarq Package by watching this video",
    "emailBody": ["See what Barb Sandelands, Chubb’s Customarq Package leader, has to say about their flagship product."],
    "facebook": "Hear what Barb Sandelands, our Customarq leader, has to say about our flagship product.",
    "twitter": "Hear what Barb Sandelands, our Customarq leader, has to say about our flagship product.",
    "linkedin": "Hear what Barb Sandelands, our Customarq leader, has to say about our flagship product.",
    "labels": "",
    "associations": [1169614, 1169602, 1169605, 1169608, 1169603, 1169611, 1169607, 1169604, 1169613, 1169610, 1169619, 1169617, 1169609, 1169606, 1169615, 1169616, 1169618, 1169612, 1169544, 1169545, 1169555, 1169546, 1169572, 1169576, 1169556, 1169573, 1169540, 1169547, 1169577, 1169536, 1169592, 1169557, 1169567, 1169558, 1169559, 1169593, 1169560, 1169578, 1169579, 1169537, 1169541, 1169580, 1169568, 1169598, 1169561, 1169581, 1169548, 1169574, 1169549, 1169582, 1169599, 1169594, 1169583, 1254995, 1249858, 1169595, 1169584, 1169551, 1169569, 1169600, 1169585, 1169552, 1169596, 1254996, 1169553, 1169586, 1169538, 1169562, 1169563, 1169587, 1169570, 1169588, 1169542, 1169589, 1169564, 1169565, 1169590]
}, {
    "id": 1169246,
    "type": "pdf",
    "src": "https:\/\/appetiteapp.chubb.com\/pdf\/t1-ip-8-18.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/pdf-ip-brochure.jpg",
    "title": "Industry Practices Flagship Brochure",
    "description": "Learn more about Industry Practices",
    "recent": false,
    "emailSubject": "Learn more about our Industry Practices, through our flagship brochure",
    "emailBody": ["You might be interested in this brochure about industry practices from Chubb. Take a look."],
    "facebook": "Learn more about our Industry Practices, through our flagship brochure",
    "twitter": "Learn more about our Industry Practices, through our flagship brochure",
    "linkedin": "Learn more about our Industry Practices, through our flagship brochure",
    "labels": "",
    "associations": [1169614, 1169602, 1169605, 1169608, 1169603, 1169611, 1169607, 1169604, 1169613, 1169610, 1169619, 1169617, 1169609, 1169606, 1169615, 1169616, 1169618, 1169612, 1169544, 1169545, 1169555, 1169546, 1169572, 1169576, 1169556, 1169573, 1169540, 1169547, 1169577, 1169536, 1169592, 1169557, 1169567, 1169558, 1169559, 1169593, 1169560, 1169578, 1169579, 1169537, 1169541, 1169580, 1169568, 1169598, 1169561, 1169581, 1169548, 1169574, 1169549, 1169582, 1169599, 1169594, 1169583, 1254995, 1249858, 1169595, 1169584, 1169551, 1169569, 1169600, 1169585, 1169552, 1169596, 1254996, 1169553, 1169586, 1169538, 1169562, 1169563, 1169587, 1169570, 1169588, 1169542, 1169589, 1169564, 1169565, 1169590]
}, {
    "id": 1181669,
    "type": "link",
    "src": "https:\/\/chubbweb.chubb.com\/chubbtraining\/myBI.html",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/calc-thumb.jpg",
    "title": "Business Income Calc",
    "description": "Easy calculation of how much business income insurance your client might need.",
    "recent": false,
    "emailSubject": "Quick business income consultation.",
    "emailBody": ["Are your clients adequately protected from potential business income losses? Check out our new BI Tool to find out:"],
    "facebook": "Are your clients adequately protected from potential business income losses? Check out our new BI Tool to find out:",
    "twitter": "Are your clients adequately protected from potential business income losses? Check out our new BI Tool to find out:",
    "linkedin": "Are your clients adequately protected from potential business income losses? Check out our new BI Tool to find out:",
    "labels": "",
    "associations": [1169602, 1169605, 1169608, 1169603, 1169611, 1169607, 1169604, 1169613, 1169610, 1169619, 1169609, 1169606, 1169615, 1169616, 1169618, 1169612, 1169544, 1169545, 1169555, 1169546, 1169572, 1169576, 1169556, 1169573, 1169540, 1169547, 1169577, 1169536, 1169592, 1169557, 1169567, 1169558, 1169559, 1169593, 1169560, 1169578, 1169579, 1169537, 1169541, 1169580, 1169568, 1169598, 1169561, 1169581, 1169548, 1169574, 1169549, 1169582, 1169599, 1169594, 1169583, 1254995, 1249858, 1169595, 1169584, 1169551, 1169569, 1169600, 1169585, 1169552, 1169596, 1254996, 1169553, 1169586, 1169538, 1169562, 1169563, 1169587, 1169570, 1169588, 1169542, 1169589, 1169564, 1169565, 1169590]
}, {
    "id": 1185199,
    "type": "pdf",
    "src": "https:\/\/www.chubb.com\/_global-assets\/documents\/chubb_advancedmanufacturing_033018.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/webapp_thumbnail_advancedmanu.jpg",
    "title": "Advanced Manufacturing Overview",
    "description": "Learn more about Advanced Manufacturing solutions",
    "recent": true,
    "emailSubject": "Learn more about Advanced Manufacturing",
    "emailBody": ["You might be interested in this brochure about Advanced Manufacturing coverage from Chubb. Take a look."],
    "facebook": "You might be interested in this brochure about Advanced Manufacturing coverage from Chubb. Take a look.",
    "twitter": "You might be interested in this brochure about Advanced Manufacturing coverage from Chubb. Take a look.",
    "linkedin": "You might be interested in this brochure about Advanced Manufacturing coverage from Chubb. Take a look.",
    "labels": "",
    "associations": [1169576, 1169577, 1169578, 1169579, 1169580, 1169581, 1169582, 1169583, 1169584, 1169585, 1169586, 1169587, 1169588, 1169589, 1169590]
}, {
    "id": 1185298,
    "type": "pdf",
    "src": "https:\/\/www.chubb.com\/_global-assets\/documents\/t2-cmarqpkg-2-18.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/webapp_thumbnail_cmarkt2.jpg",
    "title": "Customarq Package Overview",
    "description": "Learn more about Customarq Package",
    "recent": true,
    "emailSubject": "What sets Customarq Package apart?",
    "emailBody": ["Take a deeper dive into what sets Customarq apart"],
    "facebook": "What sets Customarq Package apart?",
    "twitter": "What sets Customarq Package apart?",
    "linkedin": "What sets Customarq Package apart?",
    "labels": "",
    "associations": [1169606]
}, {
    "id": 1185300,
    "type": "pdf",
    "src": "https:\/\/www.chubb.com\/_global-assets\/documents\/chubb_inlandmarine_060118.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/webapp_thumbnail_inlandmarine.jpg",
    "title": "Inland Marine Overview",
    "description": "Learn more about Inland Marine solutions",
    "recent": true,
    "emailSubject": "Learn more about Inland Marine",
    "emailBody": ["You might be interested in this brochure about Inland Marine coverage from Chubb. Take a look."],
    "facebook": "You might be interested in this brochure about Inland Marine coverage from Chubb. Take a look.",
    "twitter": "You might be interested in this brochure about Inland Marine coverage from Chubb. Take a look.",
    "linkedin": "You might be interested in this brochure about Inland Marine coverage from Chubb. Take a look.",
    "labels": "",
    "associations": [1169610]
}, {
    "id": 1185301,
    "type": "pdf",
    "src": "https:\/\/www.chubb.com\/_global-assets\/documents\/chubb_lifesciences_052418_1.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/webapp_thumbnail_lifesciences.jpg",
    "title": "Life Sciences Overview",
    "description": "Learn more about Life Sciences solutions",
    "recent": true,
    "emailSubject": "Learn more about Life Sciences",
    "emailBody": ["You might be interested in this brochure about Life Sciences coverage from Chubb. Take a look."],
    "facebook": "You might be interested in this brochure about Life Sciences coverage from Chubb. Take a look.",
    "twitter": "You might be interested in this brochure about Life Sciences coverage from Chubb. Take a look.",
    "linkedin": "You might be interested in this brochure about Life Sciences coverage from Chubb. Take a look.",
    "labels": "",
    "associations": [1169592, 1169593, 1169594, 1169595, 1169596]
}, {
    "id": 1191032,
    "type": "pdf",
    "src": "https:\/\/www.chubb.com\/_global-assets\/documents\/t2-cleantech-4-18.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/webapp_industry_clean-tech.jpg",
    "title": "Clean Technology Overview",
    "description": "Learn more about our Clean Technology Industry Practice",
    "recent": true,
    "emailSubject": "Chubb's Clean Technology Industry Practice",
    "emailBody": ["Check out how Chubb is well-positioned to craft holistic insurance solutions to address the evolving Clean Technology industry."],
    "facebook": "You might be interested in this brochure about Chubb’s Clean Technology industry practice. Take a look.",
    "twitter": "You might be interested in this brochure about Chubb’s Clean Technology industry practice. Take a look.",
    "linkedin": "You might be interested in this brochure about Chubb’s Clean Technology industry practice. Take a look.",
    "labels": "",
    "associations": [1169536]
}, {
    "id": 1245161,
    "type": "pdf",
    "src": "https:\/\/appetiteapp.chubb.com\/pdf\/t2-technology-12-18.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/technology.jpg",
    "title": "Technology Overview",
    "description": "Learn more about our Technology Industry Practice",
    "recent": true,
    "emailSubject": "Chubb's Technology Industry Practice",
    "emailBody": ["Check out how Chubb is well-positioned to proactively help businesses in the technology industry face an ever-expanding array of complex exposures."],
    "facebook": "You might be interested in this brochure about Chubb's Technology industry practice. Take a look.",
    "twitter": "You might be interested in this brochure about Chubb's Technology industry practice. Take a look.",
    "linkedin": "You might be interested in this brochure about Chubb's Technology industry practice. Take a look.",
    "labels": "",
    "associations": [1169567, 1169568, 1169569, 1169570]
}, {
    "id": 1245162,
    "type": "pdf",
    "src": "https:\/\/appetiteapp.chubb.com\/pdf\/t2-wholesale-2-19.pdf",
    "brightcove": false,
    "videoId": "",
    "playerId": "",
    "playerKey": "",
    "thumbnail": "https:\/\/appetiteapp.chubb.com\/img\/resources\/wholesale-trade.jpg",
    "title": "Wholesale Trade Overview",
    "description": "Learn more about our Wholesale Trade Industry Practice",
    "recent": false,
    "emailSubject": "Chubb's Wholesale Trade Industry Practice",
    "emailBody": ["Check out how Chubb is well-positioned to proactively help businesses in the wholesale trade industry face an ever-expanding array of complex exposures."],
    "facebook": "You might be interested in this brochure about Chubb's Wholesale Trade industry practice. Take a look.",
    "twitter": "You might be interested in this brochure about Chubb's Wholesale Trade industry practice. Take a look.",
    "linkedin": "You might be interested in this brochure about Chubb's Wholesale Trade industry practice. Take a look.",
    "labels": "",
    "associations": [1169565]
}];

export default resources;



// WEBPACK FOOTER //
// ./src/data/resources.js